export const DISMISS_ANSWER_FROM_PROCESS_STATEMENT_SUCCESS = 'DISMISS_ANSWER_FROM_PROCESS_STATEMENT_SUCCESS';

export const dismissAnswerFromProcessStatementSuccess = processStatement => ({
    type: DISMISS_ANSWER_FROM_PROCESS_STATEMENT_SUCCESS,
    payload: { processStatement },
});
